
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

export const signOutUser = async (): Promise<void> => {
  try {
    if (window._loadingIndicator) {
      window._loadingIndicator.startRequest();
    }
    
    // Set a timeout to prevent hanging in loading state
    const logoutTimeout = setTimeout(() => {
      if (window._loadingIndicator) {
        window._loadingIndicator.endRequest();
      }
      toast.error("Sign out timed out. Please try again.");
    }, 5000);
    
    await supabase.auth.signOut();
    clearTimeout(logoutTimeout);
    toast.success("You have been signed out successfully.");
  } catch (error: any) {
    toast.error("Error signing out: " + error.message);
  } finally {
    if (window._loadingIndicator) {
      window._loadingIndicator.endRequest();
    }
  }
};

export const refreshUserSession = async (setIsLoading: (loading: boolean) => void): Promise<{ data: any; error: any }> => {
  try {
    setIsLoading(true);
    
    if (window._loadingIndicator) {
      window._loadingIndicator.startRequest();
    }
    
    // Set a timeout to prevent hanging in loading state
    const refreshTimeout = setTimeout(() => {
      setIsLoading(false);
      if (window._loadingIndicator) {
        window._loadingIndicator.endRequest();
      }
      toast.error("Session refresh timed out. Please try again.");
    }, 5000);
    
    const result = await supabase.auth.refreshSession();
    clearTimeout(refreshTimeout);
    
    return result;
  } catch (error: any) {
    toast.error("Failed to refresh session: " + error.message);
    return { data: null, error };
  } finally {
    setIsLoading(false);
    
    if (window._loadingIndicator) {
      window._loadingIndicator.endRequest();
    }
  }
};
